import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Field } from "react-final-form";
import {
  Condition,
  Error,
  required,
  isEmail,
  composeValidators,
  needsLogin,
  ucFirst,
} from "./Shared";
import * as select from "../../reducers";

import * as actionsModals from "../../actions/modals";
import * as actionsSession from "../../actions/session";

import { useForm, useField } from "react-final-form";
import { displayAddress, saveGoogleAddress } from "../../helpers/Address";
import Geosuggest from "react-geosuggest";
import GoogleMapsLoader from "react-google-maps-loader";
import LoginOrSignUpModal from "./LoginOrSignUpModal";
import { Phone } from "../Forms";

function preventReturnKeyPress(e) {
  const event = e || window.event;

  const key = event.charCode || event.keyCode || 0;

  if (key === 13) {
    e.preventDefault();
  }
}

const BlockReturnKeyPress = () => {
  useEffect(() => {
    document.addEventListener("keydown", preventReturnKeyPress);

    return () => {
      document.removeEventListener("keydown", preventReturnKeyPress);
    };
  }, []);

  return null;
};

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var australianStates = {
  NSW: "New South Wales",
  VIC: "Victoria",
  QLD: "Queensland",
  TAS: "Tasmania",
  SA: "South Australia",
  WA: "Western Australia",
  NT: "Northern Territory",
  ACT: "Australian Capital Territory",
};
class DetailsClass extends React.Component {
  state = {
    isLoginModalOpen: false,
    location: null,
    manualAddressEntry: false,
  };

  getUserLocation = (googleMaps) => {
    const { location } = this.state;
    if (location || !googleMaps) {
      return;
    }
    const self = this;
    if (window.navigator) {
      window.navigator.geolocation.getCurrentPosition(
        function success(position) {
          // for when getting location is a success
          // eslint-disable-next-line no-undef
          const geolocation = new google.maps.LatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });

          self.setState({
            location: geolocation,
          });
        },
        function error(error_message) {
          // for when getting location results in an error
          console.error(
            "An error has occured while retrieving location",
            error_message
          );
          //   ipLookUp()
        }
      );
    }
  };

  onLogin = (vals) => {
    const formState = this.props.formApi.getState();
    const user = this.props.authedUser;

    if (user.organisation_name !== "") {
      this.props.setFieldValue("is_organisation", "1");
      this.setFieldValue(
        formState,
        "organisation_name",
        user.organisation_name
      );
    }

    this.setFieldValue(formState, "email", user.email, true);

    //Honorifics:
    if (
      user.honorific &&
      !["mr", "mrs", "ms", "miss"].includes(user.honorific.toLowerCase())
    ) {
      this.setFieldValue(formState, "honorific_other", user.honorific, true);
      this.setFieldValue(formState, "honorific", "other", true);
    } else {
      this.setFieldValue(formState, "honorific", ucFirst(user.honorific), true);
    }

    this.setFieldValue(formState, "first_name", user.first_name);
    this.setFieldValue(formState, "last_name", user.last_name);
    this.setFieldValue(formState, "phone", user.phone);

    const address_line_1 = user.address_line_1 ? user.address_line_1 : "";
    const address_line_2 = user.address_line_2 ? user.address_line_2 : "";
    const city = user.city ? user.city : "";
    const state = user.state ? user.state : "";
    const zip = user.zip ? user.zip : "";
    const country = user.country ? user.country : "";

    this.setFieldValue(
      formState,
      "find_my_address",
      displayAddress(user).display,
      true
    );
    this._geoSuggest.update(displayAddress(user).display);

    this.setFieldValue(formState, "address_line_1", address_line_1, true);
    this.setFieldValue(formState, "address_line_2", address_line_2, true);
    this.setFieldValue(formState, "city", city, true);
    this.setFieldValue(formState, "state", state, true);
    this.setFieldValue(formState, "zip", zip, true);
    this.setFieldValue(formState, "country", country, true);

    const {
      accounts: { CreditCard, DirectDebit } = {
        CreditCard: undefined,
        DirectDebit: undefined,
      },
    } = user;

    this.setFieldValue(
      formState,
      "prefered_dd_payment",
      DirectDebit ? JSON.stringify(DirectDebit) : "new"
    );
    this.setFieldValue(
      formState,
      "prefered_cc_payment",
      CreditCard ? JSON.stringify(CreditCard) : "new"
    );

    this.setState({
      isLoginModalOpen: false,
    });
  };

  updateAutocompleteValue = () => {
    const formState = this.props.formApi.getState();
    const currentValues = formState.values;
    this.props.setFieldValue(
      "find_my_address",
      displayAddress(currentValues).display
    );
  };

  updateManualAddressValues = (suggest) => {
    if (typeof suggest.gmaps === "undefined") {
      return;
    }
    const { address_line_1, address_line_2, city, state, zip, country } =
      suggest && suggest.gmaps && suggest.gmaps.address_components
        ? saveGoogleAddress(suggest.gmaps.address_components)
        : {};

    this.props.setFieldValue("address_line_1", address_line_1);
    this.props.setFieldValue("address_line_2", address_line_2);
    this.props.setFieldValue(
      "city",
      city.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      })
    );
    this.handleStateChange(state);
    // this.props.setFieldValue('state', state);
    this.props.setFieldValue("zip", zip);
    this.props.setFieldValue("country", country);

    setTimeout(() => {
      this.updateAutocompleteValue();
    });
  };

  setFieldValue = (state, field, value, force = false) => {
    if (force === false && state.touched[field] && state.values[field]) {
      return;
    }
    this.props.setFieldValue(field, value);
    //state.values[field] = value
  };

  handleStateChange = (inputValue) => {
    const value = inputValue.trim(); //remove whitespace as stops the matching
    if (australianStates.hasOwnProperty(value.toUpperCase())) {
      this.props.setFieldValue("country", "Australia");
      setTimeout(() => {
        this.props.setFieldValue("state", value.toUpperCase());
      });
    } else {
      let state = value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      let stateObjects = Object.keys(australianStates).map(function (itm) {
        return australianStates[itm];
      });

      if (stateObjects.indexOf(state) > -1) {
        this.props.setFieldValue("country", "Australia");
        setTimeout(() => {
          this.props.setFieldValue(
            "state",
            Object.keys(australianStates)[stateObjects.indexOf(state)]
          );
        });
      } else {
        this.props.setFieldValue("state", value);
      }
    }
  };

  render() {
    const { isAuthed, formApi, handleLogin, canType } = this.props;
    const { location, manualAddressEntry, existingUser } = this.state;

    const handleOpenModal = (event) => {
      const text = String(
        event?.target?.value || formApi.getState().values.email
      );
      const isValid = text.toLowerCase().match(emailRegex);
      if (isValid) {
        this.setState({ existingUser: { target: { value: text } } });
      }
    };

    return (
      <div id="detailsForm" className="form donation_panel__content">
        {!canType && <BlockReturnKeyPress />}
        <div className="form__block">
          <div className="row donation_panel__group donation_panel__row align-center">
            <h3 className="col-2 donation_panel__title">Donate as an:</h3>
            <div className="col-5 form__radioGroup">
              <div className="form__radio col-4">
                <Field
                  type="radio"
                  component="input"
                  name="is_organisation"
                  className="radio_input"
                  value="0"
                  id="as-individual"
                />
                <label htmlFor="as-individual" className="radio_label">
                  Individual
                </label>
              </div>
              <div className="form__radio col-4">
                <Field
                  type="radio"
                  component="input"
                  name="is_organisation"
                  value="1"
                  id="as-organisation"
                />
                <label htmlFor="as-organisation" className="radio_label">
                  Organisation
                </label>
              </div>
            </div>
          </div>
          <div className="">
            <Condition when="is_organisation" is="1">
              <h3 className="col-12 donation_panel__title">
                Organisation Details
              </h3>
              <div className="row donation_panel__row donation_panel__group">
                <div className="col-12">
                  <label>Organisation Name</label>
                  <Field
                    component="input"
                    id="organisation_name"
                    name="organisation_name"
                    validate={required}
                    autoComplete="organization"
                    className="flex-row__stretch "
                    label="Organisation Name"
                    type="text"
                    disabled={
                      formApi.getState()?.initialValues?.organisation_name
                    }
                  />
                  <Error name="organisation_name" />
                </div>
              </div>
            </Condition>
            <Condition when="is_organisation" is="0">
              <h3 className="col-12 donation_panel__title">Personal Details</h3>
            </Condition>
            <div className="row donation_panel__group">
              <div className="col-12">
                {!canType && (
                  <div className="form__alert small form_checkbox_basic mt--12">
                    <div className="flex-row">
                      Submit your email to either login, activate your AFES
                      account or continue as a guest.
                    </div>
                  </div>
                )}
              </div>
              <div className={canType ? "col-12" : "col-9"}>
                <label>Email</label>
                <Field
                  component="input"
                  type="email"
                  label=""
                  id="email"
                  name="email"
                  autoComplete="email"
                  placeholder="john@doe.com"
                  disabled={isAuthed}
                  validate={composeValidators(
                    required,
                    isEmail,
                    needsLogin(isAuthed)
                  )}
                  onBlur={handleOpenModal}
                />
                <Error name="email" />
              </div>
              {!canType && (
                <div className="col-3 mt--16">
                  <button
                    style={{ width: "100%" }}
                    className="btn__solid save-button"
                    onClick={handleOpenModal}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
            {canType && (
              <div className="row donation_panel__row donation_panel__group">
                <div className="col-2">
                  <label>Title</label>
                  <Field
                    validate={required}
                    component="select"
                    name="honorific"
                    id="title"
                    label="Title"
                    autoComplete="honorific-prefix"
                    style={{ height: 40 }}
                  >
                    <option value="" disabled>
                      Select title
                    </option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                    <option value="Miss">Miss</option>
                    <option value="other">Other</option>
                  </Field>
                  <Error name="honorific" />
                  <Condition when="honorific" is="other">
                    <div className="mt--12">
                      <label>Other Title</label>
                      <Field
                        component="input"
                        type="text"
                        id="honorific_other"
                        name="honorific_other"
                        autoComplete="honorific-prefix"
                        className="flex-row__stretch "
                        style={{ width: "100%" }}
                        validate={required}
                      />
                      <Error name="honorific_other" />
                    </div>
                  </Condition>
                </div>
                <div className="col-5">
                  <label>First Name</label>
                  <Field
                    component="input"
                    validate={required}
                    type="text"
                    id="first_name"
                    name="first_name"
                    autoComplete="given-name"
                    className="flex-row__stretch "
                  />
                  <Error name="first_name" />
                </div>
                <div className="col-5">
                  <label>Last Name</label>
                  <Field
                    component="input"
                    validate={required}
                    type="text"
                    label="Last Name"
                    id="last-name"
                    name="last_name"
                    autoComplete="family-name"
                    className="flex-row__stretch "
                  />
                  <Error name="last_name" />
                </div>
              </div>
            )}
            {canType && (
              <div className="row donation_panel__group">
                <div className="col-6">
                  <label>Mobile Number</label>
                  <Field
                    component="input"
                    type="text"
                    id="mobile"
                    name="mobile"
                    className="flex-row__stretch "
                  >
                    {({ input }) => (
                      <Phone
                        {...input}
                        value={input.value || ""}
                        onChange={input.onChange}
                      />
                    )}
                  </Field>
                  <Error name="mobile" />
                </div>
                <div className="col-6">
                  <label>Phone Number</label>
                  <Field
                    component="input"
                    type="text"
                    label=""
                    id="phone"
                    name="phone"
                    className="flex-row__stretch "
                  >
                    {({ input }) => (
                      <Phone
                        {...input}
                        value={input.value || ""}
                        onChange={input.onChange}
                      />
                    )}
                  </Field>
                  <div className="form_note">Please include area code</div>
                  <Error name="phone" />
                </div>
              </div>
            )}

            {canType && !manualAddressEntry && (
              <div className="row donation_panel__row donation_panel__field">
                <div className="col-12">
                  <label>Address Details</label>
                  <Field
                    placeholder="Enter your address..."
                    id="find_my_address"
                    name="find_my_address"
                    autoComplete=""
                    className="flex-row__stretch "
                  >
                    {(props) => (
                      <GoogleMapsLoader
                        render={(googleMaps) =>
                          googleMaps && (
                            <Geosuggest
                              ref={(el) => (this._geoSuggest = el)}
                              googleMaps={googleMaps}
                              {...props.input}
                              onFocus={(e) => {
                                this.getUserLocation(googleMaps);
                                return props.input.onFocus(e);
                              }}
                              initialValue={props.input.value}
                              location={location}
                              radius={location ? 500 : 0}
                              onSuggestSelect={(suggest) => {
                                this.updateManualAddressValues(suggest || {});
                              }}
                              types={["street_address"]}
                              country={["au", "nz"]}
                              onChange={(e) => {
                                this.updateManualAddressValues({});
                              }}
                            />
                          )
                        }
                        params={{
                          key: "AIzaSyAubC93k4zSylXwyxx_HbiZ1ylfwMbxEE4", // Define your api key here
                          libraries: "places", // To request multiple libraries, separate them with a comma
                        }}
                      />
                    )}
                  </Field>
                  <p className="form_note">
                    Having trouble finding your address?&nbsp;
                    <button
                      type="button"
                      className="btn btn__link--text"
                      onClick={() =>
                        this.setState({
                          manualAddressEntry: true,
                        })
                      }
                    >
                      You can enter your address manually.
                    </button>
                  </p>
                </div>
              </div>
            )}
            {canType && manualAddressEntry && (
              <React.Fragment>
                <div className="donation_panel__address">
                  <div className="row donation_panel__row donation_panel__field">
                    <div className="col-8">
                      <label>Address Line 1</label>
                      <Field name="address_line_1" validate={required}>
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="Street address, P.O. box, company name, c/o"
                            id="address_line_1"
                            autoComplete="address-line1"
                            className="flex-row__stretch "
                            validate={required}
                            {...input}
                            onBlur={(e) => {
                              this.updateAutocompleteValue();
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="address_line_1" />
                    </div>
                  </div>
                  <div className="row donation_panel__row donation_panel__field">
                    <div className="col-8">
                      <label>Address Line 2</label>
                      <Field name="address_line_2">
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="Street address, P.O. box, company name, c/o"
                            id="address_line_2"
                            autoComplete="address-line2"
                            className="flex-row__stretch "
                            {...input}
                            onBlur={(e) => {
                              this.updateAutocompleteValue();
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="row donation_panel__row donation_panel__field">
                    <div className="col-4">
                      <label>City</label>
                      <Field name="city" validate={required}>
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="city"
                            id="city"
                            autoComplete="address-level2"
                            className="flex-row__stretch "
                            {...input}
                            onBlur={(e) => {
                              this.props.setFieldValue(
                                "city",
                                e.target.value.replace(
                                  /\w\S*/g,
                                  function (txt) {
                                    return (
                                      txt.charAt(0).toUpperCase() +
                                      txt.substr(1).toLowerCase()
                                    );
                                  }
                                )
                              );
                              setTimeout(() => {
                                this.updateAutocompleteValue();
                              });
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="city" />
                    </div>
                  </div>
                  <div
                    className="row donation_panel__row donation_panel__field"
                    style={{ alignItems: "flex-start" }}
                  >
                    <div className="col-4 donation_panel__field">
                      <label>State</label>
                      <Field name="state" validate={required}>
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="state"
                            id="state"
                            autoComplete="address-level1"
                            className="flex-row__stretch "
                            {...input}
                            onBlur={(e) => {
                              let value = e.target.value;
                              this.handleStateChange(value);

                              this.updateAutocompleteValue();
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="state" />
                    </div>
                    <div className="col-4 donation_panel__field">
                      <label>Postcode/Zip Code</label>
                      <Field name="zip" validate={required}>
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="zip"
                            id="zip"
                            autoComplete="postal-code"
                            className="flex-row__stretch "
                            {...input}
                            onBlur={(e) => {
                              this.updateAutocompleteValue();
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="zip" />
                    </div>
                  </div>
                  <div className="row donation_panel__row donation_panel__field">
                    <div className="col-4 donation_panel__field">
                      <label>Country</label>
                      <Field name="country" validate={required}>
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="country"
                            id="country"
                            autoComplete="country-nam"
                            className="flex-row__stretch "
                            {...input}
                            onBlur={(e) => {
                              this.updateAutocompleteValue();
                              input.onBlur(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="country" />
                    </div>
                  </div>
                </div>
                <p className="form_note">
                  <button
                    className="btn btn__link--text"
                    onClick={() =>
                      this.setState({
                        manualAddressEntry: false,
                      })
                    }
                  >
                    Enter your address via google address lookup.
                  </button>
                </p>
              </React.Fragment>
            )}
          </div>
          {canType && (
            <div className="bolder-error">
              <Error name="address" />
            </div>
          )}
        </div>
        <LoginOrSignUpModal
          open={existingUser !== undefined}
          existingUser={existingUser}
          handleClose={() => this.setState({ existingUser: undefined })}
          handleOpen={() => this.setState({ existingUser: true })}
          formApi={formApi}
          handleLogin={handleLogin}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuthed: select.getIsLoggedIn(state),
    authedUser: select.getSessionUserdata(state),
    userCreditCard: select.getSettingsCreditCard(state),
    userDirectDebit: select.getSettingsDirectDebit(state),
    isLoginModalOpen: state.modals.LoginFormOpen,
    ...ownProps,
  };
};

const ConnectedDetails = connect(mapStateToProps, {
  ...actionsModals,
  ...actionsSession,
})(DetailsClass);

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ setIsAuthedOrGuest, canType, isAuthed, ...props }) {
  const formApi = useForm();
  const fields = {
    first_name: useField("first_name"),
    last_name: useField("last_name"),
    honorific: useField("honorific"),
    honorific_other: useField("honorific_other"),
    email: useField("email"),
    phone: useField("phone"),
    is_organisation: useField("is_organisation"),
    organisation_name: useField("organisation_name"),
    find_my_address: useField("find_my_address"),
    address_line_1: useField("address_line_1"),
    address_line_2: useField("address_line_2"),
    city: useField("city"),
    state: useField("state"),
    zip: useField("zip"),
    country: useField("country"),
    prefered_dd_payment: useField("prefered_dd_payment"),
    prefered_cc_payment: useField("prefered_cc_payment"),
  };

  const noThanks = useField("noThanks");
  const signUp = useField("signUp");

  const setFieldValue = (field, value) => {
    fields[field].input.onChange(value);
  };

  useEffect(() => {
    setIsAuthedOrGuest(
      !!isAuthed || noThanks.input.value || signUp.input.value
    );
  }, [setIsAuthedOrGuest, isAuthed, noThanks, signUp]);

  return (
    <ConnectedDetails
      canType={canType}
      formApi={formApi}
      setFieldValue={setFieldValue}
      isAuthed={isAuthed}
      {...props}
    />
  );
}
